import { OrderPayablesToolPanel } from "../../OrderPayablesToolPanel";
import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverSettlementHold extends Layout {
    layoutOrderPayablesToolPanel: OrderPayablesToolPanel;
    panelTaskFilters: Panel;
    sourceOrderPayablesCache: DataSource;
    tableDriverSettlement: Table;
}
